export default {
    accepted_by: "Accept",
    additional_costs: "Expences",
    additional_discount_correction: "Adjustment for additional discount",
    additional_income: "Additional Income",
    admin_statistics_future: "Administrator statistics on new Appointments for future dates",
    administrator_percent: "Administrator's percent",
    administrator_sum: "Administrator's sum",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "All visits to this branch, regardless of status, including canceled",
    apply: "Apply",
    assistant_percent: "Assistant's percent",
    assistant_sum: "Assistant's sum",
    average_cheque: "Average cheque",
    average_conversion_per_doctor_per_day: "Average indicator per doctor per day",
    average_conversion_per_doctor_per_period: "Average indicator per doctor per period",
    average_qty_of_goods_in_cheque: "Average number of items in a receipt",
    balance_amount: "Paid from deposit",
    balance_return: "Deposit return",
    became_permanent: "Became permanent",
    by: "By",
    by_means: "By method of payment",
    by_services: "By Services",
    calculated_from_calendar_visit_duration: "Calculated from the duration of the entry in the calendar",
    came_again: "Came again",
    came_among_patients: "Therefrom came",
    came_later_over_total_primary: "Percentage of repeat visitors from first-time visitors",
    cancel_date: "Cancellation date",
    cancel_reason: "Cancellation reason",
    cancelled_among_them: "Of these were canceled",
    cancelled_visits: "Cancelled appointments",
    cash_flow_statement: "Cashflow statement",
    cash_received_report_day_explanation: "Funds received for the period: payments for visits (except for such types of payments as deposit, bonus, guarantee, etc.) plus funds from replenishment / withdrawal of deposit",
    cashdesk_report: "Cashdesk report",
    conversion: "Conversion",
    conversion_came_to_permanent: "Conversion (came -> permanent)",
    cos: "Prime costs",
    cost_of_attracting_primary_patient: "Cost of attracting a primary patient",
    cost_of_materials: "Material cost",
    cost_of_visits_for_selected_interval: "Cost of visits completed during the selected interval",
    costs: "Expences",
    crm_leads_analytics: "CRM leads analytics",
    curator_id: "Curator's id",
    curator_name: "Curator's name",
    curator_percent: "Curator's percent",
    curator_sum: "Curator's sum",
    daily_report: "Daily report",
    debt_payments: "Debt payment",
    debt_writeoff: "Debt discharge",
    debtor: "Debtor",
    debtors: "Debtors",
    debtors_statement: "Debtors statement",
    deleted_payments_registry: "Deleted payments registry",
    deposit_movements: "Deposit movements",
    deposit_reconciliation_report: "Deposit reconciliation report",
    details_by_visits: "Details by visits",
    did_not_came_again: "Did not come again",
    did_not_come_among_patients: "Therefrom did not come",
    doctor_load_percent: "Doctor load percent",
    doctor_name: "Doctor",
    doctor_percent: "Doctor's interest",
    doctor_salary: "Doctor's wage",
    doctor_statistics: "Doctors statistics",
    doctor_sum: "Doctors amount",
    doctors_conversion: "Doctors' conversion",
    doctors_load: "Doctors' load",
    duration: "Duration",
    export_from: "Export from",
    exports: "Exports",
    f057: "Form 057",
    first_visit_date: "Date of first visit",
    first_visit_doctor: "Doctor of first visit",
    full_name: "Name",
    general_percent: "Total interest",
    have_later_visits_independent_of_interval: "There are future entries regardless of the selected interval",
    have_later_visits_within_selected_interval: "There are further entries in the selected interval",
    have_no_later_visits_independent_of_interval: "No further entries regardless of the selected interval",
    hidden_columns: "Hidden columns",
    hide_cancelled_visits: "Hide cancelled visits",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Payment per visit for the entire time, regardless of the selected reporting interval",
    in_progress: "In progress",
    includes_both_discount_on_specific_services_and_general_discount: "Includes discounts on specific services and a general discount on the visit",
    including_adjustment_for_general_visit_discount: "Includes adjustment for total visit discount",
    including_weighted_average_adjustment_for_general_visit_discount: "Includes weighted average adjustment for total discount per visit",
    income_by_doctors: "Income by Doctors",
    income_by_services: "Income by Services",
    initiator: "Initiator",
    invoiced: "Invoice issued",
    last_visit_date: "Date of last visit",
    last_visit_doctor: "Doctor of last visit",
    last_visit_recommendation: "Last visit recommendations",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "List of patients with visits to this branch for the selected interval",
    margins: "Gross profit",
    materials_movement_analytics: "Materials movement analytics",
    minutes_visit_was_opened_in_control_system: "Minutes the visit was opened in the 'start and end of visits' control system",
    next_visit_date: "Date of next visit",
    next_visit_doctor: "Doctor of next visit",
    number_of_patient_visits_for_given_interval: "Number of patient visits for the selected interval",
    only_fiscal_cheques: "Only fiscal cheques",
    only_fiscal_payments: "Only fiscal payments",
    only_paid: "Only paid",
    operation_type: "Operation type",
    orthodontist: "Orthodontist",
    orthopedist: "Orthopedist",
    paid_for: "Paid for",
    paid_from_account: "Paid from account",
    paid_invoices: "Paid Invoices",
    paid_sum: "Payment amount",
    patient_deposits: "Patient deposits",
    patient_id: "Patient id",
    patient_name: "Patient",
    patient_source: "Patient source",
    patient_status: "Patient status",
    patients_conversion: "Patients' conversion",
    payments_registry: "Payment register",
    payments_within_interval_for_visits_happened_within_interval: "The amount of payments for the selected interval only for visits that took place during the selected interval",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Amount of payments for the selected interval only for visits completed during the selected interval (no refunds)",
    pdf_report: "Pdf report",
    permanent_among_patients: "Therefrom loyal patients visits",
    pl_statement: "Profit and loss statement",
    plan_treatment_complexes: "Complexes",
    plan_treatments: "Treatment plan",
    previous_visit_date: "Previous visit date",
    price_before_discount: "Amount before Discount",
    primary: "Primary",
    primary_among_patients: "Therefrom first-come patients visits",
    primary_marketing_expenses: "Primary marketing expenses",
    primary_records: "Primary - recorded",
    primary_records_came: "Primary - came",
    primary_records_cancelled: "Primary - canceled",
    primary_records_did_not_come: "Primary - did not come",
    primary_records_further: "Primary - recorded later",
    primary_records_revenue: "Primary - revenue",
    product_name: "Product name",
    recorded_later: "Re-recorded",
    records: "Records",
    records_count: "Number of visits",
    refunds_within_interval: "Refunds for the selected interval",
    repeated: "Repeated",
    repeated_records: "Repeated - recorded",
    repeated_records_came: "Repeated - came",
    repeated_records_cancelled: "Repeated - canceled",
    repeated_records_did_not_come: "Repeated - did not come",
    repeated_records_further: "Repeated - recorded later",
    repeated_records_revenue: "Repeated - revenue",
    report_days_limit: "Reports period limit (days)",
    report_is_too_heavy_confirm: "The report is too large to be viewed on a page, do you want to export the report to an excel file?",
    revenue: "Revenue",
    revenue_per_hour: "Revenue per hour",
    revenues: "Revenues",
    revenues_report_day_explanation: "Payments for visits for the selected period in all ways, plus additional income (from accounting) and funds from the sale of goods",
    salary_report: "Salary report",
    saldo: "Nett",
    sale_date: "Date of sale",
    sales_funnel_applications: "Sales funnel: Applications",
    sales_funnel_plans: "Sales funnel: Treatment plans",
    see_all: "See all",
    see_only_yourself: "See only yourself",
    services_amount: "Services amount",
    show_block_as_free_time: "Show blocks as free time",
    show_completed_visits: "Show completed visits",
    show_deleted: "Show deleted",
    show_deleted_doctors: "Show deleted doctors",
    show_only_new_patients: "Show only new patients",
    source_of_patient_acquisition: "Initial source of patient attraction",
    source_of_visit_acquisition: "Visit creation source",
    source_type: "Source type",
    technic_percent: "Technician's interest",
    technic_sum: "Technician amount",
    therapist: "Basic generalist doctor",
    total_acquiring_deductions: "Total acquiring deductions",
    total_cost_of_services: "Total cost of services",
    total_materials_deductions: "Total materials deductions",
    total_patients: "Number of patients who made an appointment",
    total_payments: "Total payments",
    total_primary: "Total primary",
    total_primary_patients_records: "Total records of primary patients",
    total_revenue: "Total revenue",
    total_salary: "Total salary",
    total_technic_laboratory_deductions: "Total deductions for technicians / laboratories",
    total_unique_primary_patients: "Total unique primary patients",
    total_with_deductions: "Total with deductions",
    unique_patients_recorded_during_selected_report_interval: "Number of unique patients recorded in the selected report interval",
    unique_patients_with_first_visit_for_interval: "Unique patients with an initial visit within a selected interval",
    unpaid_invoices: "Unpaid invoices",
    updated_date: "Updated date",
    visit_id: "Visit Id",
    visit_price_including_all_discounts: "Cost of visit including all discounts",
    visit_statistics: "Visit statistics",
    visits_by_source: "Visits by source",
    visits_cost_over_services_count: "Cost of visits per number of services",
    visits_detailed: "Visits (detailed)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Visits to this branch that have services marked or a status other than 'did not arrive'",
    visits_of_current_branch_which_have_services_or_have_status_came: "Visits with services or the status 'patient arrived'",
    visits_price_including_all_discounts: "Cost of visits including all discounts",
    where_came_from: "Came from",
    who_cancelled: "Who cancelled",
    who_changed_status: "Who changed status (paid / came)",
    who_created: "Who created",
    who_updated: "Who updated",
    with_patient: "With patient",
    worked_days: "Worked days",
    worked_hours: "Worked hours",
    your_report_is_processing: "Your report is being processed. You will receive a notification as soon as it is ready."
}
